import gql from 'graphql-tag'
import { EnumFields } from '..'

export const ResourceTypeFragment = gql`
  fragment ResourceType on resource_type {
    ${EnumFields}
  }
`
